import { Field, Select } from '../../../components/ui';
import { useT } from '../../../i18n';
import type { AiModelOption } from '../../ai-model/types';

/**
 * Ô chọn model đọc chữ (chỉ model `can_read_pages`). Tên model là dữ liệu nghiệp vụ, không dịch;
 * model mặc định của tổ chức thêm hậu tố `(mặc định)` qua catalog.
 */
export function ChonModelDocChu({
  ds,
  dangTai,
  value,
  onChange,
  error,
}: {
  ds: AiModelOption[];
  dangTai: boolean;
  value: string | undefined;
  onChange: (key: string) => void;
  error?: string;
}) {
  const { t } = useT();
  const rong = !dangTai && ds.length === 0;
  return (
    <Field
      label={t('khoOcr.modelDoc')}
      required
      hint={rong ? undefined : t('khoOcr.modelDocMo')}
      error={rong ? t('khoOcr.chuaCoModelDoc') : error}
    >
      {(p) => (
        <Select<string>
          {...p}
          className="w-full"
          loading={dangTai}
          disabled={rong}
          placeholder={t('khoOcr.chonModelDoc')}
          value={value}
          onChange={onChange}
          options={ds.map((m) => ({
            value: m.key,
            label: m.is_default ? t('hauTo.macDinh', { nhan: m.label }) : m.label,
          }))}
        />
      )}
    </Field>
  );
}
